<template>
    <p class="rf-text"><a href="https://www.economie.gouv.fr/plan-de-relance" target="_blank" title="Consulter l’ensemble des mesures du plan de relance du Gouvernement - nouvelle fenêtre">Consulter l’ensemble des mesures du plan de relance du Gouvernement</a>.</p>
</template>

<script>
    export default {
        name: "infoPlan",
    }
</script>
